import { IntegrationConnection } from '@aibees/elephant/types/integration';
import { DropDownOption } from '@aibees/shared/components';

export function useConvertDataToDropDownOption(
  integrationConnections?: IntegrationConnection[]
) {
  return (integrationConnections?.map((item) => ({
    key: item.id,
    value: item,
    label: item.name,
    startIcon: 'key-outline',
  })) || []) as DropDownOption[];
}
